import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import NotFound from "Components/NotFound";
import Button, { Link } from "ds/Button";
import Sellable from "src/organization/common/components/sellableBanners/Sellable";
import Illustration from "Vendor_resources/images/construction-cone.svg";

import * as S from "../sellable/ProfilingSellable.styles";

import ProfilingPageTitle from "./ProfilingPageTitle";

const ObservabilitySuiteUpgrade = () => {
  const intl = useIntl();

  return (
    <>
      <S.BannerWrapper>
        <Sellable size="large" sellableName="observability_suite">
          <S.ObsSellableContent>
            <S.SellableTitle className="header">
              {intl.formatMessage({
                id: "upgrade_to_observability_suite_title"
              })}
            </S.SellableTitle>

            <Typography.BodyText className="description">
              {intl.formatMessage({
                id: "upgrade_to_observability_suite_description"
              })}
            </Typography.BodyText>
            <S.ObsButtonGroup>
              <Button
                analyticId="contact_sales"
                target="_blank"
                href={intl.formatMessage({ id: "links.contact" })}
              >
                {intl.formatMessage({ id: "contact_sales" })}
              </Button>
              <Button
                target="_blank"
                variant="secondary"
                className="learn-more"
                analyticId="learnmore"
                href={intl.formatMessage({
                  id: "links.observability-suite-features"
                })}
              >
                {intl.formatMessage({ id: "learnmore" })}
              </Button>
            </S.ObsButtonGroup>
          </S.ObsSellableContent>
        </Sellable>
      </S.BannerWrapper>

      <div>
        <ProfilingPageTitle />
        <NotFound
          title={intl.formatMessage({
            id: "continuous_profiling_not_available"
          })}
          illustration={Illustration}
        >
          <Typography.BodyText>
            {intl.formatMessage({
              id: "continuous_profiling_observability_suite"
            })}
          </Typography.BodyText>
          <Link
            target="_blank"
            href={intl.formatMessage({
              id: "links.observability-suite-features"
            })}
            analyticId="observability-suite_learnmore"
          >
            {intl.formatMessage({ id: "observability-suite_learnmore" })}
          </Link>
        </NotFound>
      </div>
    </>
  );
};

export default ObservabilitySuiteUpgrade;
